/**
 * getStowagInstruction2dbayview endpoint
 */
export type ColorPalette = {
	color: string;
	text: string;
	description: string;
	count: number;
}

export type Cell = {
	containerNo?: number | null;
	containerCycleId?: number | null;
	lineOperator?: string | null;
	isoCode?: number;
	portOfDischarge?: any;
	color?: string;
	existed: boolean;
	isReefer: boolean;
	is40Foot: boolean;
	isInForAndAfter: boolean;
	isInBay: boolean
	is45Foot: boolean;
	isHazardous: boolean;
	isEmpty: boolean;
	isHighCube: boolean;
	isBreakBulk: boolean;
	blink:boolean;
	stowageInstructionDetailCellId:number
}

export type OnDeck = {
	rows: number;
	cols: number;
	cells: Cell[];
}


export type Hold = {
	rows: number;
	cols: number;
	cells: Cell[];
}

export type VesselBay = {
	vesselBayType: number;
	sequense: number;
	vesselProfileHatchId: number;
	bay: string;
	onDeck: OnDeck;
	hold: Hold;
}


export interface VesselHatche {
	vesselProfileHatchId: number;
	vesselBays: VesselBay[];
}

export interface StowagInstructionData {
	colorPalettes: ColorPalette[];
	vesselHatches: VesselHatche[];
}



export type StowagInstructionResponse = {
	data: StowagInstructionData;
	isSuccessful: boolean;
	tag?: string;
	message: Message[];
	errorField?: never;
}


export interface StowagInstructionContainerDetailData {
	containerNo: string;
	position: string;
	isoCode: string;
	lineOperator: string;
	containerType: string;
	length: string;
	status: string;
	height: string;
	teu: number;
	weight?: any;
	weightGroup?: any;
	portOfLoad: string;
	portOfDischarge: string;
	polTerminal?: any;
	podTerminal?: any;
	destination?: any;
	isHazardous: boolean;
	isOOG: boolean;
	bundle: boolean;
	isReefer: boolean;
}



export interface ErrorField { }

export interface StowagInstructionContainerDetailRequest {
	containerNo: string;
	voyageId: number;
}

export interface StowagInstructionContainerDetailResponse {
	data: StowagInstructionContainerDetailData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField: ErrorField;
}



export enum StowagInstructionView {
  SingleBay=1,
  MiniOneBayWide=2, //Mini - One bay wide
  MiniAllBays=3 //Mini - All bays
}

export enum StowagInstructionDeck{
  Both=1,
  Above=2, 
  Below=3
}

export enum StowagInstructionType {
  Discharge=1,
  Load=2,
  Restow=3,
  Inventory=4
}

export enum StowagInstructionStatus {
  Plan =1,
  InProgress=2,
  Done=3,
  All=4
}


export type StowagInstructionRequest = {
  bay?: number;
  colorBy: number;
  deck?: StowagInstructionDeck;
  status: string;
  MonitoringType: StowagInstructionType;
  view: StowagInstructionView;
  voyageId: number
}

/**
 * ColorBy endpoint
 */

export type ColorBy = {
	id: number;
	name: string;
}

export type ColorByData = {
  colorByList: ColorBy[];
}


export type ColorByResponse = {
	data: ColorByData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}


/**
 * GetStowagInstructionView endpoint
 */

export type StowagInstructionViewData= {
	id: number;
	name: string;
}


export type StowagInstructionViewResponse = {
	data: StowagInstructionViewData[];
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}

/**
 * GetBayByVoyageId endpoint
 */

export type Bay = {
	bay: number;
	bayNo: string;
}

export type BayList = Bay[];

export type BayByVoyageIdData = {
	bayList: BayList;
}

export type BayByVoyageIdResponse = {
	data: BayByVoyageIdData;
	isSuccessful: boolean;
	tag?: any;
	message: Message[];
	errorField?: any;
}


/**
 * General
 */
export type Message = {
	messageText: string;
	messageType: number;
}





















